import {
    doNotModifyCodeAbove,
    doNotModifyCodeBelow,
} from "@js/educationContent/CairoMummiesContent/eduConstants";

export const lesson0DefaultStartCode = `%lang starknet

// Boolean assertions, such as "x OR y" for boolean felts, can also be implemented without conditionals.


// TODO Implement the following boolean asserts without "if"

${doNotModifyCodeAbove}`;

export const lesson0DefaultMiddleCode = `func assert_or(x, y) {
    // TODO: FILL ME IN
    return ();
}

func assert_and(x, y) {
    // TODO: FILL ME IN
    return ();
}

func assert_nor(x, y) {
    // TODO: FILL ME IN
    return ();
}

func assert_xor(x, y) {
    // TODO: FILL ME IN
    return ();
}`;

export const lesson0DefaultEndCode = `${doNotModifyCodeBelow}
@external
func test_assert_or() {
    assert_or(0, 1);
    assert_or(1, 0);
    assert_or(1, 1);
    return ();
}

@external
func test_assert_or_ko() {
    %{ expect_revert() %}
    assert_or(0, 0);
    return ();
}

@external
func test_assert_and() {
    assert_and(1, 1);
    return ();
}

@external
func test_assert_and_ko1() {
    %{ expect_revert() %}
    assert_and(0, 0);
    return ();
}

@external
func test_assert_and_ko2() {
    %{ expect_revert() %}
    assert_and(0, 1);
    return ();
}

@external
func test_assert_and_ko3() {
    %{ expect_revert() %}
    assert_and(1, 0);
    return ();
}

@external
func test_assert_nor() {
    assert_nor(0, 0);
    return ();
}

@external
func test_assert_nor_ko1() {
    %{ expect_revert() %}
    assert_nor(0, 1);
    return ();
}

@external
func test_assert_nor_ko2() {
    %{ expect_revert() %}
    assert_nor(1, 0);
    return ();
}

@external
func test_assert_nor_ko3() {
    %{ expect_revert() %}
    assert_nor(1, 1);
    return ();
}

@external
func test_assert_xor() {
    assert_xor(0, 1);
    assert_xor(1, 0);
    return ();
}

@external
func test_assert_xor_ko() {
    %{ expect_revert() %}
    assert_xor(0, 0);
    return ();
}

@external
func test_assert_xor_ko2() {
    %{ expect_revert() %}
    assert_xor(1, 1);
    return ();
}`;
